import * as React from "react";
import { Card, CardContent, CardHeader } from '@material-ui/core';

export default () => (
    <Card>
        <CardHeader title="Welcome to Quiz editor" />
        <CardContent>We will add, edit or remove item...</CardContent>
    </Card>
);